export default __webpack_public_path__ + "static/media/pattern.8155a677.jpg";